// Renders a subscription amount at exactly two decimal places. Mirrors
// formatMoney in emr-api (src/audit-daily-summary/helpers/format-money.ts) so
// the VDV table here and the audit email there agree character for character.
export const formatMoney = (
  currency: string | null | undefined,
  amount: unknown,
): string => {
  const fixed = (Number(amount) || 0).toFixed(2);
  return currency ? `${currency} ${fixed}` : fixed;
};
